module.exports = __webpack_public_path__ + "static/media/reportPageIconColored.1f26e30e.svg";